module.exports = __webpack_public_path__ + "static/img/layout3.6ab41416.jpg";